import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ListPage } from "../../components/ListPage";
import { DocumentStatusTag } from "../../components/DocumentStatusTag";
import { hasAnyGrant } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import type { QuotationRequest } from "../../api-models";

export default function RFQsListPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const canWrite = hasAnyGrant(user, "Quotations.Write");

  return (
    <ListPage<QuotationRequest>
      title="Quotation Requests (RFQ)"
      endpoint="/qrequests"
      searchPlaceholder="Search doc no or notes..."
      linkTo={(r) => `/procurement/rfqs/${r.id}`}
      actions={
        canWrite && (
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate("/procurement/rfqs/new")}>
            New RFQ
          </Button>
        )
      }
      columns={[
        { title: "Doc No", dataIndex: "docNo", sorter: true },
        { title: "Status", dataIndex: "status", sorter: true, render: (v) => <DocumentStatusTag status={v} /> },
      ]}
    />
  );
}
